import { createContext } from 'react';

export const CalculationContext = createContext(null);
